import { gql } from '@/__generated__';

const CREATE_DEVICE_OBSERVATION = gql(`#graphql
  mutation DeviceObservation_CreateObservation(
    $input: CreateDeviceObservationInput!
  ) {
    createDeviceObservation(input: $input) {
      author {
        id
      }
      device {
        id
      }
      date
      content
      id
    }
  }
`);

export default CREATE_DEVICE_OBSERVATION;
